import { gql } from '@apollo/client';

const HypothesisFieldsFragment = gql`
  fragment HypothesisFields on Hypothesis {
    mean
    observedCount
    sampleSize
    standardDeviation
    variant
  }
`;

const HypothesisStatsDataFieldsFragment = gql`
  fragment HypothesisStatsDataFields on HypothesisStatsData {
    chanceToOutperform
    confidenceInterval {
      lowerBound
      upperBound
    }
    conversionRate
    criticalValue
    dof
    effectSize
    executedSimulations
    pValue
    simulationsExecutionTime
    standardError
    statisticalPower
    statisticalSignificance
    testScore
    delta
    lift
    errorMessage
  }
`;

const NullHypothesisStatsDataFieldsFragment = gql`
  fragment NullHypothesisStatsDataFields on NullHypothesisStatsData {
    conversionRate
    standardError
    errorMessage
  }
`;

const ExperimentResultFieldsFragment = gql`
  fragment ExperimentResultFields on ExperimentResult {
    hypothesesStats {
      ...HypothesisStatsDataFields
    }
    nullHypothesisStats {
      ...NullHypothesisStatsDataFields
    }
  }
  ${HypothesisStatsDataFieldsFragment}
  ${NullHypothesisStatsDataFieldsFragment}
`;

export const SignificanceDataFieldsFragment = gql`
  fragment SignificanceDataFields on SignificanceData {
    hypotheses {
      ...HypothesisFields
    }
    hypothesisResults {
      ...ExperimentResultFields
    }
    isEmpty
    metric
    nullHypothesis {
      ...HypothesisFields
    }
  }
  ${HypothesisFieldsFragment}
  ${ExperimentResultFieldsFragment}
`;
